<script>
    import router from "page";
    import { onMount } from "svelte";

    import { fetchGet, fetchPatch } from "../utils/utilsFetch.js";

    import { messageObject, isLoading } from "../stores.js";

    let brands = [];
    let filteredBrands = [];

    let searchQuery = "";

    onMount(async () => {
        $isLoading = true;
        brands = await fetchGet(`/api/brands`);
        filteredBrands = brands;
        $isLoading = false;
    });

    function search() {
        if (searchQuery.length == 0) {
            filteredBrands = brands;
        } else {
            filteredBrands = brands.filter((brand) =>
                brand.brand.toLowerCase().includes(searchQuery.toLowerCase())
            );
        }
    }
</script>

<div class="container">
    <input
        type="text"
        bind:value={searchQuery}
        on:input={search}
        placeholder="Пребарај..."
    />

    <div class="brands">
        {#each filteredBrands as brand}
            <a href="/products?brand={brand.brand}">
                <div class="brand">
                    {brand.brand}
                </div>
            </a>
        {/each}
    </div>
</div>

<style>
    .container {
        padding: 20px;

        height: 85vh;
    }

    input {
        width: 100%;
        margin-bottom: 10px;
        padding: 10px;
    }

    .brands {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;

        height: 100%;

        overflow: auto;
    }

    .brand {
        padding: 20px;
        background: white;
        border-radius: 5px;
        margin: 10px;
        box-shadow: 0px 2px 5px 0px rgb(0 0 0 / 20%);
    }

    .brand:hover {
        cursor: pointer;
        box-shadow: 0px 2px 5px 0px rgb(0 0 0 / 50%);
    }
</style>
